/**
 * Calendar page
 */
function irCalendarPage() {
	if (!document.querySelector('main.subpage.ir-page.calendar')) return;

	// Initialize calendar event buttons (Google Calendar and Outlook)
	initCalendarButtons();

	const select = document.getElementById('events-years-filter');
	const events = document.querySelectorAll('.event');

	function filterEvents(year) {
		events.forEach(event => {
			const eventYear = event.dataset.year;
			event.style.display = (eventYear == year) ? '' : 'none';
		});
	}

	const urlParams = new URLSearchParams(window.location.search);
	const yearFromUrl = urlParams.get('rok');

	if (yearFromUrl) {
		select.value = yearFromUrl;
		filterEvents(yearFromUrl);
	} else {
		filterEvents(select.value);
	}

	select.addEventListener('change', function () {
		const selectedYear = this.value;

		filterEvents(selectedYear);

		const newUrl = new URL(window.location.href);
		newUrl.searchParams.set('rok', selectedYear);
		window.history.replaceState({}, '', newUrl);
	});

}
